import React from 'react';
import { Route } from 'react-router-dom';
import { SignupRoutes } from './routes/SignupRoutes';

export const routes = [<Route path="/account-signup" key="route--signup" component={SignupRoutes} />];
